<template>
  <div
    :class="qaClass('panel', index)"
    class="c-panel c-panel--full u-mrgn-bottom--0">
    <a :href="subscriptionUrl">
      <div class="c-panel__item">
        <div class="o-layout">
          <div class="o-layout__item u-1of4">
            <a :href="miUrl" data-no-turbolink="true" >
              <img
                :src="product.logo_url"
                width="37px"
                height="37px" >
            </a>
          </div>
          <div class="o-layout__item u-3of4 u-pad-left--3">
            <div>
              <a :href="productUrl" data-no-turbolink="true" class="u-txt--base u-fg--black inline">
                <EllipsisText :lineNum=1 :message="product.name" />
              </a>
            </div>
            <div class="u-txt--small">
              <a :href="typeUrl" data-no-turbolink="true" class="u-fg--black">{{ product.type }} </a>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import { money } from 'shared/helpers/numberHelper';
import EllipsisText from 'shared/components/Ellipsis/EllipsisText';
import {
  generateSeoTypeUrl,
  generateSeoProductUrl,
  generateSeoInvestmentManagerUrl,
} from 'shared/helpers/seoMap';

export default {
  name: 'ProductItem',
  components: {
    EllipsisText
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    typeUrl() {
      return generateSeoTypeUrl(this.product.type);
    },
    miUrl() {
      return generateSeoInvestmentManagerUrl(this.product.im_code);
    },
    productUrl() {
      return generateSeoProductUrl(this.product.isin_code);
    },
    subscriptionUrl() {
      return `/bukareksa/subscription/${this.product.isin_code}`;
    }
  },
  methods: {
    qaClass(object, idx) {
      return `qa-br-product-${object}-${idx + 1}`;
    },
  },
};
</script>

<style scoped>
.inline {
  display: inline-block;
}
</style>

